import { render, staticRenderFns } from "./MppMoneyPay.vue?vue&type=template&id=eaf847bc&scoped=true"
import script from "./MppMoneyPay.vue?vue&type=script&lang=js"
export * from "./MppMoneyPay.vue?vue&type=script&lang=js"
import style0 from "./MppMoneyPay.vue?vue&type=style&index=0&id=eaf847bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf847bc",
  null
  
)

export default component.exports